export function validatePhoneNumber(phoneNumber) {
  const phoneNumberPattern = /^\d{10}$/;
  return phoneNumberPattern.test(phoneNumber);
}

export function validateEmailAddress(emailAddress) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(emailAddress);
}

export const validateSouthAfricanIdNumber = (idNumber) => {
  if (!idNumber || idNumber.length !== 13) return false;

  const idYear = idNumber.substring(0, 2);
  const idMonth = idNumber.substring(2, 4);
  const idDay = idNumber.substring(4, 6);

  try {
    const date = new Date(idYear, idMonth - 1, idDay);

    const dateYear = date.getFullYear().toString();

    let dateMonth = (date.getMonth() + 1).toString();
    if (dateMonth < 10) {
      dateMonth = `0${dateMonth}`;
    } else {
      dateMonth = dateMonth.toString();
    }

    let dateDay = date.getDate();
    if (dateDay < 10) {
      dateDay = `0${dateDay}`;
    } else {
      dateDay = dateDay.toString();
    }

    if (dateYear.slice(2, 4) !== idYear) return false;
    if (dateMonth !== idMonth) return false;
    if (dateDay !== idDay) return false;
  } catch (error) {
    return false;
  }

  const gender = parseInt(idNumber.substring(6, 10));
  if (gender < 1 || gender > 9999) return false;

  const citizenship = idNumber.substring(10, 11);
  if (citizenship !== '0' && citizenship !== '1') return false;

  let checkSum = 0;
  for (let i = 0; i < idNumber.length; i++) {
    let value = parseInt(idNumber[i]);
    if (i % 2 !== 0) {
      value *= 2;

      if (value > 9) {
        value -= 9;
      }
    }

    checkSum += value;
  }

  if (checkSum % 10 !== 0) return false;

  return true;
};
